import {Box, Card, CardContent, Typography} from '@mui/material';

export default function AdminSeedQuestionListEmpty() {
  return (
    <Card>
      <CardContent>
        <Box sx={{textAlign: 'center', py: 4}}>
          <Typography variant="h6" sx={{color: '#666', mb: 1}}>
            No seed questions found
          </Typography>
          <Typography variant="body2" sx={{color: '#999'}}>
            Select a module and click "Fetch Seed Questions" to load seed questions.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
